/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Checkbox,
  Dropdown,
  Container,
  Segment,
  Icon,
  Table,
} from "semantic-ui-react";
import {
  withFormik,
  Field as Fieldmik,
  FieldArray,
  Form as Formiker,
} from "formik";
import { connect } from "react-redux";
import MandatoryMark from "../common/mandatorymark";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { MyInput } from "../dynamicComponent/myInputs";
import { translate } from "react-i18next";
import VehicleSearch from "../createShipmentComponent/vehicleSearch";
import SearchDropdownD from "../createShipmentComponent/searchDropdownD";
import MyVehicleType from "../apiInputs/myVehicleType";
import MyTrackingType from "../apiInputs/myTrackingType";
import MyServiceProvider from "../apiInputs/mySerivceProvider";
import MyVehicleOwnership from "../apiInputs/myVehicleOwnerShip";
import ReadAxios from "../axiosComponent/read";
import { REQUIRED_FIELDS, INVALID_FIELDS } from "../../utils/validationConstant";
import { AllRegex } from "../../utils/validation";


const BookingVehicleDetailsModal = ({
  values, touched, errors, isSubmitting, handleSubmit, setFieldValue, t, movementType, order, modalOpen, handleClose, ...props
}) => {

  useEffect(() => {
    setFieldValue('ownership_type', order?.ownership_type_id)
  }, [order?.ownership_type_id])

  useEffect(() => {
    setFieldValue('vehicle_type', order?.required_vehicle_type)
  }, [order?.required_vehicle_type])

  useEffect(() => {
    getOwnershipValues()
  },[])

  const [ownershipValues, setOwnershipValues] = useState([])

  const getOwnershipValues = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleOwnershipType`
    }).then((result) => {
      let options = []
      let content = result?.data?.resultSet?.length ? result?.data?.resultSet : [];
      if (content.length > 0) {
        content.map((object, index) => {
          let temp = {}
          temp.key = object.vehicleOwnershipTypeId
          temp.text = object.vehicleOwnershipTypeName
          temp.value = object.vehicleOwnershipTypeId
          return options[index] = temp
        })
      }
      setOwnershipValues(options)
    }).catch((err) => {
      console.log(err);
    })
  }

  const setVehicleNumber = (name, data) => {
    if (data?.raw) {
      setFieldValue('vehicle_number', data?.raw?.vehicleNumber)
      setFieldValue('vehicle_id', data?.raw?.vehicleId)
      setFieldValue('vehicle_type', data?.raw?.vehicleTypeId)

      if (data?.raw?.vehicleOwner) {
        let ownershipName = `${data?.raw?.vehicleOwner} Vehicle`
        let ownershipObj = ownershipValues.find((owner) => owner?.text?.toUpperCase() == ownershipName.toUpperCase())
        if (ownershipObj) setFieldValue('ownership_type', ownershipObj?.value)
      }
    } else {
      setFieldValue('vehicle_number', data)
    }
  }

  const setDriverName = (name, data) => {
    if (data?.raw) {
      setFieldValue("driver_name", data?.raw?.driverName)
      setFieldValue("driver_id", data?.raw?.driverMasterId)
      setFieldValue("driver_number", data?.raw?.driverContact)
      setFieldValue("network_provider", data?.raw?.serviceProviderId)
    } else {
      setFieldValue("driver_name", data)
    }
  }

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="fullscreen"
        className="padding-5-imp"
      >
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
            <label className="font-weight-normal">{"Add Vehicle Details"}</label>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content>
          <div className="ui tiny form">
            <Formiker>
              <Segment className="padding-4-imp">
                <div className="ui form tiny p-bold-600">

                  <FormUi.Group className="padding-15px_lr">
                    <FormUi.Field width={3}>
                      <label>
                        {t("table_header.vehicle_type") || "Vehicle Type"}{" "}
                        <MandatoryMark />
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={3} className="display-grid-center-imp">
                      <Fieldmik
                        component={MyVehicleType}
                        name="vehicle_type"
                        restrictSearch={true}
                        clearable
                        value={values.vehicle_type}
                      />
                      {touched.vehicle_type && errors.vehicle_type ? (
                        <p className="error-msg">
                          {errors.vehicle_type}
                        </p>
                      ) : null}
                    </FormUi.Field>
                    <FormUi.Field width={1} />
                    <FormUi.Field width={3}>
                      <label>
                        {t("table_header.vehicle_number") ||
                          "Vehicle Number"}{" "}
                        <MandatoryMark />
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={3} className="display-grid-center-imp">
                      <VehicleSearch
                        setField={setVehicleNumber}
                        masterRoute={
                          "vendorMaster/vehicles/" + order?.vendor_id
                        }
                        masterRouteKey="vehicleId"
                        masterRouteName="vehicleNumber"
                        fieldName="vehicle_number"
                      // placeholder={vehicleNumber}
                      />
                      {touched.vehicle_number && errors.vehicle_number ? (
                        <p className="error-msg">
                          {errors.vehicle_number}
                        </p>
                      ) : null}
                    </FormUi.Field>
                  </FormUi.Group>

                  <FormUi.Group className="padding-15px_lr" >
                    <FormUi.Field width={3}>
                      <label>
                        {t("table_header.ownership_type") ||
                          "Ownership Type"}{" "}
                        <MandatoryMark />
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={3} className="display-grid-center-imp">

                      <Fieldmik
                        component={MyVehicleOwnership}
                        name="ownership_type"
                        value={values.ownership_type}
                        clearable
                        options={ownershipValues}
                      />
                      {touched.ownership_type && errors.ownership_type ? (
                        <p className="error-msg">
                          {errors.ownership_type}
                        </p>
                      ) : null}
                    </FormUi.Field>
                    <FormUi.Field width={1} />
                    <FormUi.Field width={3}>
                      <label>
                        {t("table_header.tracking_type") || "Tracking Type"}{" "}
                        <MandatoryMark />
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={3} className="display-grid-center-imp">
                      <Fieldmik
                        component={MyTrackingType}
                        name="tracking_type"
                        value={values.tracking_type}
                        clearable
                      />
                      {touched.tracking_type && errors.tracking_type ? (
                        <div className="error-msg">
                          {t(
                            `tracking_type.error_msg.${errors.tracking_type}`
                          ) || errors.tracking_type}
                        </div>
                      ) : null}
                    </FormUi.Field>
                  </FormUi.Group>

                  <FormUi.Group
                    className="vehicle-detail-heading-wrapper padding-15px_lr">
                    <FormUi.Field>
                      <h3 className="vehicle-detail-heading padding-left-0">
                        Driver Details
                      </h3>
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group className="padding-15px_lr">
                    <FormUi.Field width={3} className="display-grid-center-imp">
                      <label>
                        {t("table_header.driver_name") || "Driver Name"}{" "}
                        <MandatoryMark />
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={3}>
                      <SearchDropdownD
                        name="driver_name"
                        placeholder={values.driver_name || ""}
                        setField={setDriverName}
                        masterRoute={`driverMaster`}
                        masterRouteKey="driverMasterId"
                        masterRouteName="driverNameContactNo"
                        fieldName="driver_id"
                        vendorid={order?.vendor_id}
                      />
                      {touched.driver_name && errors.driver_name ? (
                        <>

                          <div className="error-msg">
                            {errors.driver_name}
                          </div>
                        </>
                      ) : null}
                    </FormUi.Field>
                    <FormUi.Field width={1} />
                    <FormUi.Field width={3}>
                      <label>
                        {t("table_header.driver_number") || "Driver Number"}{" "}
                        <MandatoryMark />
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={3} className="vehicle-detail-wrapper padding-0-imp-child display-grid-center-imp">
                      <Fieldmik
                        name="driver_number"
                        component={MyInput}
                        value={values.driver_number}
                        max={10}
                        error={
                          touched.driver_number && errors.driver_number
                            ? true
                            : false
                        }
                      />
                      {touched.driver_number && errors.driver_number ? (
                        <>
                          <br />
                          <p className="error-msg">
                            {errors.driver_number}
                          </p>
                        </>
                      ) : null}
                    </FormUi.Field>
                  </FormUi.Group>

                  <FormUi.Group className="padding-15px_lr">
                    <FormUi.Field width={3}>
                      <label>
                        {t("table_header.network_provider") ||
                          "Network Provider"}
                      </label>
                      {values?.tracking_type &&
                        values.tracking_type == 2 ? (
                        <MandatoryMark />
                      ) : null}
                    </FormUi.Field>
                    <FormUi.Field width={3} className="display-grid-center-imp">
                      <Fieldmik
                        component={MyServiceProvider}
                        name="network_provider"
                        value={values.network_provider}
                        clearable
                        upward
                      />
                      {touched.network_provider &&
                        errors.network_provider ? (
                        <p className="error-msg">
                          {t(errors.network_provider)}
                        </p>
                      ) : null}
                    </FormUi.Field>
                  </FormUi.Group>
                </div>
            
              </Segment>
            </Formiker>


          </div>
        </Modal.Content>
        <Modal.Actions>
        <Button
              type="submit"
              // disabled={}
              size="mini"
              className="w3-blue w3-round w3-hover-blue"
              onClick={handleSubmit}
            >
              {t("action_button.submit") || "Submit"}
            </Button>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

const FormikBookingVehicleDetailsModal = withFormik({
  validationSchema: yup.object({
    vehicle_type: yup.number().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).nullable(),
    tracking_type: yup.number().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).nullable(),
    vehicle_number: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.VehicleNumber, INVALID_FIELDS.INVALID_VEHICLE_NO).nullable(),
    ownership_type: yup.number().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).nullable(),
    driver_name: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).nullable(),
    driver_number: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_MOBILE_NO).nullable()
  }),
  mapPropsToValues: (props) => {
    return {
      vehicle_type: "",
      tracking_type: 1,
      vehicle_number: "",
      vehicle_id: "",
      ownership_type: "",
      driver_name: "",
      driver_id: "",
      driver_number: "",
      network_provider: ""
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    props.submitVehicleDetails(values);
  },
})(BookingVehicleDetailsModal);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("alloted_vehicle_details")(FormikBookingVehicleDetailsModal)
);
